<template>
  <div class="register">
    <el-form :model="input_user" :rules="rules" ref="input_user"
              label-position="left" label-width="0px"
              class="demo-ruleForm login-container">
      <div class="logo">
          <img id="ul_login_Image2" src="./imgs/loginlogo.png" class="logoimg">
      </div>

      <div class="bee">
          <img src="./imgs/bee.png" class="beeimg">
      </div>

      <el-form-item prop="username">
        <el-input type="text"  placeholder="请输入手机号码" v-model="input_user.username"></el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input type="password" placeholder="请输入密码" v-model="input_user.password"  auto-complete="off"></el-input>
      </el-form-item>

      <!-- 验证码组件 -->
      <get-verify-code :username='input_user.username'></get-verify-code>



      <el-form-item prop="getxy" style="height:35px">
        <el-checkbox class="" v-model="input_user.getxy">必胜公考用户协议</el-checkbox>
        <router-link
            class="cf-right yellcolor"
            to="/login">登录
        </router-link>
        <span class="cf-right huicolor">已有账号？,马上</span>
      </el-form-item>

      <el-form-item style="width:100%;">
        <el-button type="primary" class="bgblue" style="width:100%;"
                   @click="register" @keyup.enter="register"
                   >同意协议并注册
        </el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import md5 from 'js-md5'
import urls from '../../common/js/urls.js'
import GetVerifyCode from './GetVerifyCode'
export default {
    name: "register",
    components: {
      GetVerifyCode
    },
    data() {
      return {
        input_user: {
          username: '',
          password: '',
          verify_code: '',
          getxy:''
        },
        rules: {
          username: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1[345678]\d{9}$/, message: '手机号格式错误', trigger: 'blur'}
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          getxy: [
            { required: true, message: '请阅读《必胜公考用户协议》', trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      // 获取验证码

      setVerifyCode(val) {
        this.input_user.verify_code = val;
      },
      register() {
        var _this = this
        if (_this.input_user.verify_code=='') {
           _this.$message.error('请填写验证码');
          return false
        }
        _this.$refs.input_user.validate((valid) => {
          if (valid) {
            //_this.$store.dispatch('userLogin', _this.input_user

            _this.axios.post(urls.register + '?username=' + _this.input_user.username + '&password=' + md5(_this.input_user.password) + '&verify_code=' + _this.input_user.verify_code+'&from=web&channel=web').then(function(response) {
              if (response.data.code != 200) {
                alert(response.data.msg);
                return false
              }
              _this.$message({
                message: '注册成功！快来登录吧',
                type: 'success'
              });
              setTimeout(function() { _this.$router.go(-1) }, 1 * 1000)
            })
          } else {
            return false;
          }
        });
      }

    }
}
</script>

<style scoped>
 @import "../../common/style/login.css";
</style>



// WEBPACK FOOTER //
// src/components/Log/Register.vue